import useWorkflowDraft from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Providers/WorkflowDraftProvider/useWorkflowDraft';
import CheckboxTile from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Shared/CheckboxTile';
import SectionCard from '@Guidelines/Component/SectionCard';
import { css } from '@emotion/react';
import * as React from 'react';

const gridStyle = css`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(12.5rem, 1fr));
	gap: 0.5rem;
`;

/** The kinds of elements a preparation of this group accepts. */
const AcceptedElementsSection: React.FC = () => {
	const { draft, setDraft } = useWorkflowDraft();

	const handleInterviewsChange = React.useCallback(
		(checked: boolean) => {
			setDraft((current) => current.setAcceptsInterviews(checked));
		},
		[setDraft],
	);

	const handleNotesChange = React.useCallback(
		(checked: boolean) => {
			setDraft((current) => current.setAcceptsNotes(checked));
		},
		[setDraft],
	);

	const handleDocumentsChange = React.useCallback(
		(checked: boolean) => {
			setDraft((current) => current.setAcceptsDocuments(checked));
		},
		[setDraft],
	);

	return (
		<SectionCard
			title="Éléments acceptés dans la préparation"
			description="Ce que le professionnel peut rassembler avant de générer."
		>
			<div css={gridStyle}>
				<CheckboxTile
					name="acceptsInterviews"
					label="Entretiens"
					checked={draft.acceptsInterviews}
					onChange={handleInterviewsChange}
				/>
				<CheckboxTile
					name="acceptsNotes"
					label="Notes dictées ou saisies"
					checked={draft.acceptsNotes}
					onChange={handleNotesChange}
				/>
				<CheckboxTile
					name="acceptsDocuments"
					label="Documents du dossier"
					checked={draft.acceptsDocuments}
					onChange={handleDocumentsChange}
				/>
			</div>
		</SectionCard>
	);
};

export default AcceptedElementsSection;
